import { isEditableRow } from '../../../shared/columns/tools/headingTools';

export const isEditableForTbnRow = (params) =>
    isEditableRow(params) && params.data.vessel?.isTbn;
